import { INPUT_VALUE_REGEX } from './constants';

export const getValidatedValue = (value, min, max) => Math.min(Math.max(value, min), max);

export const getIsInputValueValid = inputValue =>
  INPUT_VALUE_REGEX.test(inputValue) && !Number.isNaN(Number(inputValue));

export const getHoverAreaSize = ({ initialSize, distance }) =>
  distance < 0 ? initialSize - Math.abs(distance / 2) : initialSize;

export const getSizedControls = ({ isHorizontalOrientation, size, max, min, head, tail }) => ({
  headMaxWidth: isHorizontalOrientation ? (size.width / (max - min)) * (tail - min) : size.width,
  tailMaxWidth: isHorizontalOrientation ? (size.width / (max - min)) * (max - head) : size.width,
  headMaxHeight: !isHorizontalOrientation
    ? (size.height / (max - min)) * (tail - min)
    : size.height,
  tailMaxHeight: !isHorizontalOrientation
    ? (size.height / (max - min)) * (max - head)
    : size.height,
});
